import { render } from "./ConfigSettingPage.vue?vue&type=template&id=4fe29260&ts=true"
import script from "./ConfigSettingPage.vue?vue&type=script&lang=ts"
export * from "./ConfigSettingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__